<template>
  <div class="content">
    <van-nav-bar title="开具发票" border fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#000" />
      </template>
    </van-nav-bar>

    <van-field name="invoiceType" label="发票类型">
      <template #input>
        <van-tag
          plain
          size="medium"
          :color="invoiceType === 1 ? h5Config.themeColor : ''"
          :text-color="invoiceType === 1 ? h5Config.themeColor : ''"
          @click="invoiceType = 1"
        >
          个人
        </van-tag>
      </template>
    </van-field>
    <van-field name="contentType" label="内容">
      <template #input>
        <van-tag
          plain
          size="medium"
          :color="contentType === 2 ? h5Config.themeColor : ''"
          :text-color="contentType === 2 ? h5Config.themeColor : ''"
          @click="contentType = 2"
        >
          商品类别
        </van-tag>
      </template>
    </van-field>

    <van-field v-model="title" name="title" label="抬头" placeholder="请输入抬头" />
    <van-field v-model="emailAddress" name="emailAddress" label="邮箱" placeholder="请输入邮箱" />

    <div class="bottom">
      <div class="order-amount">
        <div class="order-amount-info">
          <div class="total-amount-text">
            <span class="text-gray-600">开票金额:</span>
            <span class="order-actual-amount">¥{{ invoiceAmount }}</span>
          </div>
        </div>
      </div>
      <button class="ios-button" @click="submitInvoice"> 提交 </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { insertSaleInvoice, getSaleInvoiceList } from '@/service/saleInvoice';
  import h5Config from '@/config/config';
  import { showDialog, showSuccessToast } from 'vant';

  const route = useRoute();
  const orderCode = ref('');
  const invoiceAmount = ref(0);
  const title = ref('个人');
  const taxNo = ref('');
  const invoiceType = ref(1);
  const contentType = ref(2);
  const emailAddress = ref('');
  const isMobile = ref(true);

  onMounted(async () => {
    isMobile.value = isMobileDevice();
    orderCode.value = route.query.code || '';
    invoiceAmount.value = Number(route.query.amount || 0);
    loadInvoice();
    lockViewport();
  });

  const lockViewport = () => {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'viewport';
      document.head.appendChild(meta);
    }
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
  };

  const isMobileDevice = () => {
    if (typeof window === 'undefined') return false; // SSR 环境处理
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  };

  const loadInvoice = async () => {
    if (!orderCode.value) {
      return;
    }
    const invoiceListResp = await getSaleInvoiceList({
      pageNum: 1,
      pageSize: 1,
      data: {
        orderNo: orderCode.value,
        invoiceStatus: 10,
      },
    });
    const invoiceList = invoiceListResp?.result?.list || [];
    if (!invoiceList.length) return;

    const invoiceItem = invoiceList[0];
    const invoiceUrl = invoiceItem.invoiceUrl || '';
    if (invoiceUrl) {
      window.location.replace(invoiceUrl);
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const submitInvoice = async () => {
    if (!title.value) {
      showDialog({ message: '请输入开票名称' });
      return;
    }
    if (!invoiceAmount.value) {
      showDialog({ message: '开票金额不能为空' });
      return;
    }

    const insertInvoiceResp = await insertSaleInvoice({
      shopId: 2,
      title: title.value,
      taxNo: taxNo.value,
      orderNo: orderCode.value,
      invoiceAmount: invoiceAmount.value,
      emailAddress: emailAddress.value,
    });
    if (insertInvoiceResp.code === 200) {
      showSuccessToast({ message: '发票申请已提交，请稍后查看下载。' });
      loadInvoice();
    } else {
      showDialog({ message: insertInvoiceResp.msg || '开票失败' });
    }
  };
</script>

<style scoped lang="less">
  .content {
    margin-top: 60px;
  }

  .bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;
    z-index: 99;
    background-color: #fff;
    padding: 12px 16px;
    border: none;
    border-top: 1px solid #e5e7eb;

    .order-amount {
      flex: 1;
      text-align: left;

      .order-amount-info {
        display: flex;
        font-size: 14px;
        line-height: 20px;
        color: #4b5563;
        margin-bottom: 4px;

        .total-amount-text {
          margin-right: 10px;
        }
      }

      .order-actual-amount {
        color: #ef4444;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        margin-left: 4px;
      }

      .payment-remark {
        font-size: 12px;
        line-height: 16px;
        color: #6b7280;
      }
    }

    .ios-button {
      background-color: v-bind('h5Config.themeColor');
      color: white;
      border-radius: 12px;
      padding: 12px 20px;
      font-weight: 600;
      width: auto;
      display: inline-block;
      border: none;
      font-size: 16px;
    }
  }
</style>
